import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { WorkflowChallenge } from './components/WorkflowChallenge';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Everything } from './components/Everything';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { WhyPrice } from './components/WhyPrice';
import { Guarantee } from './components/Guarantee';
import { Author } from './components/Author';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas font-sans text-ink antialiased" data-id="element-0" data-mp="23ti8k5ohswkq">
      <MetaPixel data-id="element-1" data-mp="3ii4ro0w5cqo1" />
      <Hero data-id="element-2" data-mp="3mlaxx8j9ehui" />
      <main data-id="element-3" data-mp="3ml17jjuay8oa">
        <WorkflowChallenge data-id="element-4" data-mp="3mkhn9wh6j873" />
        <BeforeAfter data-id="element-5" data-mp="3mjq2zht18ww4" />
        <PainPoints data-id="element-6" data-mp="3mj6lg27aoaim" />
        <Volumes data-id="element-7" data-mp="3rbr9so7flver" />
        <Bonuses data-id="element-8" data-mp="3rdaquh0wwahl" />
        <Everything data-id="element-9" data-mp="3rcsy3udgkeef" />
        <Testimonials data-id="element-10" data-mp="3recd7hndojem" />
        <Offer data-id="element-11" data-mp="5ygolyg4xb6" />
        <WhyPrice data-id="element-12" data-mp="6hpnd64cbd2" />
        <Guarantee data-id="element-13" data-mp="4wyzymxdckh" />
        <Author data-id="element-14" data-mp="56nfhsbnbo2" />
        <FAQ data-id="element-15" data-mp="82ohezguggq" />
        <FinalCTA data-id="element-16" data-mp="2zl3brl12165b" />
      </main>
      <Footer data-id="element-17" data-mp="2zlv3gkrj6jqb" />
      <FloatingCTA data-id="element-18" data-mp="2zmenq84nlk7i" />
      <PurchasePopup data-id="element-19" data-mp="2zmwh8wzxlkbq" />
    </div>;
}